/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
import { FC } from 'react';

import { IconBlockInfo } from 'app/components/ui/icon-block';
import { ContentDetails } from 'app/components/content-details';
import { Container } from 'app/components/content-block/container';
import { Image } from 'app/components/image';
import { Button } from '@hqo/ui-atoms';
import { ArrowLeft } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import { cn } from '@hqo/react-hooks';
import { Header } from 'app/components/header';

export interface DesktopContentBlockProps {
  title: string;
  upperSubtitle?: string;
  lowerSubtitle?: string;
  description?: string | undefined;
  richDescription?: string;
  showRichDescription?: boolean;
  descriptionTitleText?: string;
  imgUrl?: string;
  imgAltText?: string;
  haveClaimedText?: string;
  descriptionViewDetailText: string;
  iconBlocks?: Array<IconBlockInfo>;
  participantsCount?: string;
  hostedBy?: string;
  hideBackTo?: boolean;
  isMobileHost?: boolean;
  onBackClick: () => void;
}

export const DesktopContentBlock: FC<DesktopContentBlockProps> = ({
  title,
  imgAltText,
  upperSubtitle,
  lowerSubtitle,
  description,
  richDescription,
  showRichDescription,
  imgUrl,
  iconBlocks,
  descriptionTitleText,
  descriptionViewDetailText,
  participantsCount,
  haveClaimedText,
  hostedBy,
  hideBackTo,
  isMobileHost,
  onBackClick,
  ...rest
}: DesktopContentBlockProps) => (
  <Container data-testid="desktop-content-block" {...rest} className="h-full pb-5 sm:mb-[72px] w-full px-4 sm:px-6 lg:px-8">
    <div data-testid="back-to-button" className={cn('flex flex-col justify-start md:items-center py-4 w-full ', hideBackTo && 'hidden')}>
      <div className="w-full md:w-[80%]">
        <Button variant="ghost" className="w-fit has-[>svg]:px-0 hover:bg-transparent hover:font-bold" onClick={onBackClick}>
          <ArrowLeft className="w-4 h-4" />
          <FormattedMessage id="buttons.back" />
        </Button>
      </div>
    </div>
    <div className="relative w-full md:w-[80%] mb-6">
      {hideBackTo && <Header className="w-full" onBackClick={isMobileHost ? onBackClick : undefined} />}
      <Image
        src={imgUrl}
        alt={imgAltText ?? title}
        className="rounded-xl w-full h-auto object-cover max-h-120 md:max-w-[100%] lg:max-h-150"
      />
    </div>
    <ContentDetails
      title={title}
      upperSubtitle={upperSubtitle}
      lowerSubtitle={lowerSubtitle}
      description={description}
      richDescription={richDescription}
      showRichDescription={showRichDescription}
      iconBlocks={iconBlocks}
      descriptionTitleText={descriptionTitleText}
      descriptionViewDetailText={descriptionViewDetailText}
      participantsCount={participantsCount}
      haveClaimedText={haveClaimedText}
      hostedBy={hostedBy}
    />
  </Container>
  );
